import script from "./widgetWrapper.vue?vue&type=script&lang=js"
export * from "./widgetWrapper.vue?vue&type=script&lang=js"

import "./widgetWrapper.vue?vue&type=style&index=0&id=7f874e7b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f874e7b"],['__file',"src/components/widgets/common/widgetWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f874e7b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f874e7b', __exports__)) {
    api.reload('7f874e7b', __exports__)
  }
  
}


export default __exports__